import gql from 'graphql-tag';

export const MUTATION_DELETE_EQUIPMENT_COUNTING_JOURNAL = gql`
  mutation deleteEquipmentCountingJournal($id: String!) {
    deleteEquipmentCountingJournal(id: $id) {
      id
      journalNum
    }
  }
`;
